export const userFormTheme = {
  modalRoleItem: 'palette.tertiary.90',
};
